import { lazy } from "react";
import { DefaultPage } from "../structure/Page/DefaultPage/DefaultPage";
import { withAuthorization } from "../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";

const LocationsMapPageContent = lazy(() => import("./LocationsMapPageContent"));

function LocationsMapPageInternal() {
    return (
        <DefaultPage>
            <LocationsMapPageContent />
        </DefaultPage>
    );
}

export const LocationsMapPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER))(
    LocationsMapPageInternal
);
